/* eslint-disable max-len */
import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";

const routes: Routes = [
  {
    path: "",
    loadChildren: () =>
      import("./login/login.module").then((m) => m.LoginPageModule),
  },
  {
    path: "pos",
    loadChildren: () => import("./pos/pos.module").then((m) => m.PosPageModule),
  },

  {
    path: "host",
    loadChildren: () =>
      import("./host/host.module").then((m) => m.HostPageModule),
  },
  {
    path: "host-mirror",
    loadChildren: () =>
      import("./host-mirror/host-mirror.module").then(
        (m) => m.HostMirrorPageModule,
      ),
  },
  {
    path: "receipts-l",
    loadChildren: () =>
      import("./receipts-landscape/receipts-landscape.module").then(
        (m) => m.ReceiptsLandscapePageModule,
      ),
  },
  {
    path: "receipts",
    loadChildren: () =>
      import("./receipts/receipts.module").then((m) => m.ReceiptsPageModule),
  },
  {
    path: "receipt-view",
    loadChildren: () =>
      import("./receipt-view/receipt-view.module").then(
        (m) => m.ReceiptViewPageModule,
      ),
  },
  {
    path: "pos-row-edit",
    loadChildren: () =>
      import("./modal/pos-row-edit/pos-row-edit.module").then(
        (m) => m.PosRowEditPageModule,
      ),
  },
  {
    path: "pos-l",
    loadChildren: () =>
      import("./pos-landscape/pos-landscape.module").then(
        (m) => m.PosLandscapePageModule,
      ),
  },

  {
    path: "pos-cash-modal",
    loadChildren: () =>
      import("./modal/pos-cash-modal/pos-cash-modal.module").then(
        (m) => m.PosCashModalPageModule,
      ),
  },
  {
    path: "receipt-share-modal",
    loadChildren: () =>
      import("./modal/receipt-share-modal/receipt-share-modal.module").then(
        (m) => m.ReceiptShareModalPageModule,
      ),
  },
  {
    path: "configuration-modal",
    loadChildren: () => import("./modal/configuration-modal/configuration-modal.module").then( m => m.ConfigurationModalPageModule)
  },
  {
    path: "pos-card-modal",
    loadChildren: () => import("./modal/pos-card-modal/pos-card-modal.module").then( m => m.PosCardModalPageModule)
  },
  {
    path: "card-print-receipt-modal",
    loadChildren: () => import("./modal/card-print-receipt-modal/card-print-receipt-modal.module").then( m => m.CardPrintReceiptModalPageModule)
  },
  {
    path: "card-terminal-processing-modal",
    loadChildren: () => import("./modal/card-terminal-processing-modal/card-terminal-processing-modal.module").then( m => m.CardTerminalProcessingModalPageModule)
  },
  {
    path: "technical-info-modal",
    loadChildren: () => import("./modal/technical-info-modal/technical-info-modal.module").then( m => m.TechnicalInfoModalPageModule)
  },
  {
    path: "date-picker-modal",
    loadChildren: () => import("./modal/date-picker-modal/date-picker-modal.module").then( m => m.DatePickerModalPageModule)
  },
  {
    path: "sales-report",
    loadChildren: () => import("./receipts-sales-report-view/receipts-sales-report-view.module").then( m => m.ReceiptsSalesReportViewPageModule)
  },
  {
    path: "condiments-modal",
    loadChildren: () => import("./modal/condiments-modal/condiments-modal.module").then( m => m.CondimentsModalPageModule)
  },
  {
    path: "restaurant-details-modal",
    loadChildren: () => import("./modal/choose-restaurant-modal/choose-restaurant-modal.page").then( m => m.ChooseRestaurantModalPage)
  },
  {
    path: "host-layout-modal",
    loadChildren: () => import("./modal/host-layout-modal/host-layout-modal.module").then( m => m.HostLayoutModalPageModule)
  },
  {
    path: "host-select-message-modal",
    loadChildren: () => import("./modal/host-select-message-modal/host-select-message-modal.module").then( m => m.HostSelectMessageModalPageModule)
  },
  {
    path: "open-price-modal",
    loadChildren: () => import("./modal/open-price-modal/open-price-modal.module").then( m => m.OpenPriceModalPageModule)
  },
  {
    path: "guest-login-modal",
    loadChildren: () => import("./modal/guest-login-modal/guest-login-modal.module").then( m => m.GuestLoginModalPageModule)
  },
  {
    path: "guest-add-product-modal",
    loadChildren: () => import("./modal/guest-add-product-modal/guest-add-product-modal.module").then( m => m.GuestAddProductModalPageModule)
  },
  {
    path: "guest-edit-products-modal",
    loadChildren: () => import("./modal/guest-edit-products-modal/guest-edit-products-modal.module").then( m => m.GuestEditProductsModalPageModule)
  },
  {
    path: "logs",
    loadChildren: () => import("./log-view/log-view.module").then( m => m.LogViewPageModule)
  },
  {
    path: "user-switch-confirmation-modal",
    loadChildren: () => import("./modal/user-switch-confirmation-modal/user-switch-confirmation-modal.module").then( m => m.UserSwitchConfirmationModalPageModule)
  },
  {
    path: "reconciliation-confirmation-modal",
    loadChildren: () => import("./modal/reconciliation-confirmation-modal/reconciliation-confirmation-modal.module").then( m => m.ReconciliationConfirmationModalPageModule)
  },
  {
    path: "discounts",
    loadChildren: () => import("./discounts/discounts.module").then( m => m.DiscountsPageModule)
  },
  {
    path: "discount-modal",
    loadChildren: () => import("./modal/discount-modal/discount-modal.module").then( m => m.DiscountModalPageModule)
  },
  {
    path: 'choose-discount-modal',
    loadChildren: () => import('./modal/choose-discount-modal/choose-discount-modal.module').then( m => m.ChooseDiscountModalPageModule)
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
